import { style } from "@vanilla-extract/css";

export const container = style({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  minHeight: "100vh",
  paddingBlock: "var(--cp-base-spacing-3xlarge)",
  paddingInline: "var(--cp-spacing-large)",
  // Offset for the fixed 57px auth header (see auth/layout.css.ts).
  paddingBlockStart: "calc(57px + var(--cp-spacing-large))",
  backgroundColor: "var(--cp-color-white)",

  "@media": {
    "(max-width: 767px)": {
      paddingInline: "var(--cp-base-spacing-3xlarge)",
      paddingBlockStart: "57px",
    },
  },
});

export const card = style({
  width: "100%",
  maxWidth: "640px",

  "@media": {
    "(max-width: 767px)": {
      maxWidth: "100%",
    },
    "(min-width: 768px) and (max-width: 1023px)": {
      maxWidth: "640px",
    },
    "(min-width: 1024px)": {
      maxWidth: "640px",
    },
  },
});

export const header = style({
  textAlign: "center",
  marginBlockEnd: "var(--cp-spacing-3xlarge)",
});

export const title = style({
  font: "var(--cp-text-display2xlarge)",
  color: "var(--cp-color-text-primary)",
  marginBlockEnd: "var(--cp-spacing-large)",
  marginBlockStart: "0",

  "@media": {
    "(max-width: 767px)": {
      font: "var(--cp-text-display-xlarge)",
    },
  },
});

export const subtitle = style({
  font: "var(--cp-text-body-large)",
  color: "var(--cp-color-text-primary)",
  marginBlockStart: "0",
  marginBlockEnd: "0",
});

export const fullWidth = style({
  width: "100%",
});

export const backToLoginLink = style({
  display: "block",
  width: "100%",
  textDecoration: "none",
  "@media": {
    "(max-width: 767px)": { display: "none" },
  },
});

export const termsRow = style({
  display: "flex",
  alignItems: "center",
  gap: "var(--cp-spacing-small)",
});

export const termsText = style({
  font: "var(--cp-text-body-medium)",
  color: "var(--cp-color-text-primary)",
  lineHeight: "var(--cp-line-height-body-medium)",
  cursor: "pointer",
});

export const termsLink = style({
  color: "var(--cp-action-color-branded-primary-enabled)",
  textDecoration: "underline",
  cursor: "pointer",
  selectors: {
    "&:hover": {
      color: "var(--cp-action-color-branded-primary-hover)",
    },
  },
});

export const helperText = style({
  font: "var(--cp-text-body-small)",
  color: "var(--cp-color-text-secondary)",
  marginBlockStart: "var(--cp-spacing-xsmall)",
});

export const nameRow = style({
  display: "flex",
  flexDirection: "row",
  gap: "var(--cp-spacing-large)",
  "@media": {
    "(max-width: 767px)": {
      flexDirection: "column",
    },
  },
});

export const illustrationContainer = style({
  position: "relative",
  width: "120px",
  height: "120px",
  margin: "0 auto var(--cp-spacing-large)",
});

export const illustrationLayer = style({
  position: "absolute",
  inset: 0,
});

export const backLink = style({
  display: "inline-flex",
  alignItems: "center",
  gap: "var(--cp-spacing-xsmall)",
  color: "var(--cp-action-color-branded-primary-enabled)",
  textDecoration: "none",
  font: "var(--cp-text-body-medium)",
  marginBlockEnd: "var(--cp-spacing-2xlarge)",
  selectors: {
    "&:hover": {
      color: "var(--cp-action-color-branded-primary-hover)",
    },
  },
  "@media": {
    "(max-width: 767px)": { display: "none" },
  },
});

// ---------------------------------------------------------------------------
// Markets trigger — read-only TextInput displays selection
// ---------------------------------------------------------------------------

export const marketsTriggerControl = style({
  cursor: "pointer",
});

// ---------------------------------------------------------------------------
// Markets dialog interior
// ---------------------------------------------------------------------------

// Flex column shell inside DialogBody so search + list stack vertically
export const dialogInner = style({
  display: "flex",
  flexDirection: "column",
  gap: "var(--cp-base-spacing-small, 8px)",
  width: "100%",
  height: "100%",
});

export const searchField = style({
  flexShrink: 0,
});

// Fixed-height scrollable list on desktop; overridden inline on mobile
export const marketsList = style({
  height: "400px",
  overflowY: "auto",
});

export const marketItem = style({
  display: "flex",
  alignItems: "center",
  gap: "var(--cp-spacing-small)",
  paddingBlock: "var(--cp-spacing-xsmall)",
  cursor: "pointer",
});
